import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { extractParams } from '@marageti/z4-lib';
import { useAuthStore } from '../../store';

const Logout = () => {
  const { removeAuthenticatedTeamMember } = useAuthStore();
  const { search } = useLocation();

  useEffect(() => {
    removeAuthenticatedTeamMember()
      .then(() => {
        const { redirect } = extractParams(search);
        window.location.href = `/login${redirect ? search : ''}`;
      });
  }, []);

  return null;
};

export default Logout;
